import React from 'react';

export default function Background() {
  return (
    <>
      <div className="fixed inset-0 bg-[#0a0014]">
        <div className="absolute inset-0 bg-gradient-to-tr from-purple-900/30 via-transparent to-fuchsia-900/30 animate-gradient" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_800px_at_100px_100px,rgba(168,85,247,0.15),transparent)]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_800px_at_right_bottom,rgba(192,38,211,0.15),transparent)]" />
        <div className="grid grid-cols-8 h-full w-full">
          {Array.from({ length: 64 }).map((_, i) => (
            <div
              key={i}
              className="border-[0.5px] border-purple-500/[0.05] -z-10"
            />
          ))}
        </div>
      </div>
      <div className="fixed inset-0 bg-gradient-to-t from-background/10 via-purple-900/[0.02] to-background/10" />
    </>
  );
}